<template>
  <div>
    <v-dialog v-model="getRlEditDialog.show" scrollable persistent max-width="500px">
      <v-card>
        <v-card-title>
          <v-row>
            <v-col cols="12">
              <span class="headline">Edit Entry</span>
              <v-alert :value="getRlEditDialog.alert.show" dense outlined :type="getRlEditDialog.alert.type" :icon="getRlEditDialog.alert.icon">{{ getRlEditDialog.alert.message }}</v-alert>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>         
          <v-progress-linear :active="dialogLoading" height="3" indeterminate absolute color="primary" />
          <v-container>
            <v-row>
              <v-form ref="editRlForm">
                <v-row>
                  <v-col cols="12">
                    <v-select v-model="getRlEntry.entry_type_id" :items="getEntryTypeList" item-value="id" item-text="description" label="Entry Type" disabled />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-menu v-model="datePickerMenu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="getRlEntry.trans_date" prepend-icon="event" readonly v-bind="attrs" v-on="on" label="Transaction Date" dense />
                      </template>
                      <v-date-picker v-model="getRlEntry.trans_date" @input="datePickerMenu1 = false" />
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-combobox v-model="getRlEntry.coll_dest_company" :items="getCompanyListCalc" :rules="[...getRlDialogRules.required, ...getRlDialogRules.stringMax50]" counter="50" maxlength="50" label="Collection/Destination Company Name" autocomplete="off" dense />
                  </v-col>
                </v-row>
                 <v-row>
                  <v-col cols="12">
                    <v-select v-model="getRlEntry.coll_dest_country" :items="getCompanyCountryCalc" item-value="code" item-text="name" :rules="[...getRlDialogRules.required, ...getRlDialogRules.stringMax255]" clearable counter="255" maxlength="255" label="Collection/Destination Country" autocomplete="off" dense />
                  </v-col>
                </v-row>
                 <v-row>
                  <v-col cols="12">
                    <v-combobox v-model="getRlEntry.coll_dest_city" :items="getCompanyCityCalc" :rules="[...getRlDialogRules.required, ...getRlDialogRules.stringMax50]" counter="50" maxlength="50" label="Collection/Destination City" autocomplete="off" dense />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-combobox v-model="getRlEntry.coll_dest_address" :items="getCompanyAddressCalc" :rules="[...getRlDialogRules.required, ...getRlDialogRules.stringMax50]" counter="50" maxlength="50" label="Collection/Destination Contact Address" autocomplete="off" dense />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-combobox v-model="getRlEntry.coll_dest_contact_name" :items="getCompanyContactCalc" :rules="[...getRlDialogRules.required, ...getRlDialogRules.stringMax50]" counter="50" maxlength="50" label="Collection/Destination Contact Name" autocomplete="off" dense />
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="getRlEntry.coll_dest_contact_tel" :rules="[...getRlDialogRules.required, ...getRlDialogRules.stringMax50]" counter="50" maxlength="50" label="Collection/Destination Contact Tel" autocomplete="off" dense />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="getRlEntry.coll_dest_contact_email" :rules="[...getRlDialogRules.required, ...getRlDialogRules.email, ...getRlDialogRules.stringMax50]" counter="50" maxlength="50" label="Collection/Destination Contact Email" autocomplete="off" dense />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-select v-model="getRlEntry.material_id" :items="getMaterialList" item-value="id" item-text="description" :rules="getRlDialogRules.required" label="Material" dense />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-select v-model="getRlEntry.grade_id" :items="getGradeMaterialList(getRlEntry.material_id)" item-value="id" item-text="description" :rules="getRlDialogRules.required" label="Grade" no-data-text="Choose Material first" dense />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="getRlEntry.spec" :rules="getRlDialogRules.specification" label="Specification" type="text" autocomplete="off" dense />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="getRlEntry.cont_perc" suffix="%" @blur="contaminationPerc2Dec(getRlEntry)" :rules="[...getRlDialogRules.percentage]" label="Contamination Percentage" type="number" autocomplete="off" dense />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="7">
                    <v-text-field v-model="getRlEntry.material_volume" @blur="materialVolume2Dec(getRlEntry)" :rules="[...getRlDialogRules.required, ...getRlDialogRules.money]" label="Material Volume" type="number" autocomplete="off" dense />
                  </v-col>
                  <v-col cols="5">
                    <v-select v-model="getRlEntry.material_uom" :items="getUnitOfMeasureList" item-value="code" item-text="code" :rules="getRlDialogRules.required" label="Material Unit of Measure" dense />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5">
                    <v-select v-model="getRlEntry.material_unit_price_cc" :items="getCurrencyList" item-value="code" item-text="code" :rules="[...getRlDialogRules.required]" label="Currency Code" dense />
                  </v-col>
                  <v-col cols="7">
                    <v-text-field v-model="getRlEntry.material_unit_price" @blur="price2Dec(getRlEntry, 'material_unit_price_cc', 'material_unit_price')" :rules="[...getRlDialogRules.required, ...getRlDialogRules.money]" label="Material Unit Price" type="number" autocomplete="off" dense />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-select v-model="getRlEntry.incoterm_id" :items="getIncotermList" item-value="id" item-text="description" :rules="getRlDialogRules.required" label="Incoterm" dense />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5">
                    <v-select v-model="getRlEntry.PRN_PERN_price_cc" :items="getCurrencyList" item-value="code" item-text="code" @input="price2Empty(getRlEntry, 'PRN_PERN_price')" label="Currency Code" dense />
                  </v-col>
                  <v-col cols="7">
                    <v-text-field v-model="getRlEntry.PRN_PERN_price" @blur="price2Dec(getRlEntry, 'PRN_PERN_price_cc', 'PRN_PERN_price')" :rules="getRlEntry.PRN_PERN_price_cc ? [...getRlDialogRules.required, ...getRlDialogRules.money] : [true]" label="PRN/PERN Price" type="number" autocomplete="off" dense />
                  </v-col>
                </v-row>
                
                <v-switch v-model="dom_haul" prepend-icon="home" label="Domestic Haulage" dense />
                <div v-if="dom_haul">
                  <v-divider />
                  <v-row>
                    <v-col cols="5">
                      <v-select v-model="getRlEntry.dom_haul_cost_cc" :items="getCurrencyList" item-value="code" item-text="code" @input="price2Empty(getRlEntry, 'dom_haul_cost')" label="Currency Code" dense />
                    </v-col>
                    <v-col cols="7">
                      <v-text-field v-model="getRlEntry.dom_haul_cost" @blur="price2Dec(getRlEntry, 'dom_haul_cost_cc', 'dom_haul_cost')" :rules="getRlEntry.dom_haul_cost_cc ? [...getRlDialogRules.required, ...getRlDialogRules.money] : [true]" label="Domestic Haulage Cost" type="number" autocomplete="off" dense />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-combobox v-model="getRlEntry.dom_haul_company" :items="getHaulageCompanyCalc" :rules="[...getRlDialogRules.stringMax50]" counter="50" maxlength="50" label="Domestic Haulage Company" autocomplete="off" dense />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-switch v-model="getRlEntry.dom_haul_booked" label="Domestic Haulage Booked" dense />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-menu v-model="datePickerMenu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="getRlEntry.dom_haul_date" prepend-icon="event" readonly v-bind="attrs" v-on="on" label="Domestic Haulage Collection Date" clearable dense />
                        </template>
                        <v-date-picker v-model="getRlEntry.dom_haul_date" @input="datePickerMenu2 = false" />
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-divider />
                </div>

                <v-switch v-model="int_ship" prepend-icon="language" label="International Shipping" dense />
                <div v-if="int_ship">
                  <v-divider />
                  <v-row>
                    <v-col cols="5">
                      <v-select v-model="getRlEntry.int_ship_cost_cc" :items="getCurrencyList" item-value="code" item-text="code" @input="price2Empty(getRlEntry, 'int_ship_cost')" label="Currency Code" dense />
                    </v-col>
                    <v-col cols="7">
                      <v-text-field v-model="getRlEntry.int_ship_cost" @blur="price2Dec(getRlEntry, 'int_ship_cost_cc', 'int_ship_cost')" :rules="getRlEntry.int_ship_cost_cc ? [...getRlDialogRules.required, ...getRlDialogRules.money] : [true]" label="International Shipping Cost" type="number" autocomplete="off" dense />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-combobox v-model="getRlEntry.int_ship_company" :items="getShippingCompanyCalc" :rules="[...getRlDialogRules.stringMax50]" counter="50" maxlength="50" label="International Shipping Company" autocomplete="off" dense />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-switch v-model="getRlEntry.int_ship_booked" label="International Shipping Booked" dense />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-menu v-model="datePickerMenu3" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="getRlEntry.int_ship_date" prepend-icon="event" readonly v-bind="attrs" v-on="on" label="International Shipping Collection Date" clearable dense />
                        </template>
                        <v-date-picker v-model="getRlEntry.int_ship_date" @input="datePickerMenu3 = false" />
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-divider />
                </div>

                <v-row>
                  <v-col cols="5">
                    <v-select v-model="getRlEntry.insurance_cost_cc" :items="getCurrencyList" item-value="code" item-text="code" @input="price2Empty(getRlEntry, 'insurance_cost')" label="Currency Code" dense />
                  </v-col>
                  <v-col cols="7">
                    <v-text-field v-model="getRlEntry.insurance_cost" @blur="price2Dec(getRlEntry, 'insurance_cost_cc', 'insurance_cost')" :rules="getRlEntry.insurance_cost_cc ? [...getRlDialogRules.required, ...getRlDialogRules.money] : [true]" label="Insurance Cost" type="number" autocomplete="off" dense />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                     <v-combobox v-model="getRlEntry.hs2" :items="getHs2ListCalc" :rules="[...getRlDialogRules.stringMax50]" counter="50" maxlength="50" label="HS2" autocomplete="off" dense />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-combobox v-model="getRlEntry.insp_company" :items="getInspectionCompanyCalc" :rules="[...getRlDialogRules.stringMax50]" counter="50" maxlength="50" label="Inspection Company" autocomplete="off" dense />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5">
                    <v-select v-model="getRlEntry.insp_cost_cc" :items="getCurrencyList" item-value="code" item-text="code" @input="price2Empty(getRlEntry, 'insp_cost')" label="Currency Code" dense />
                  </v-col>
                  <v-col cols="7">
                     <v-text-field v-model="getRlEntry.insp_cost" @blur="price2Dec(getRlEntry, 'insp_cost_cc', 'insp_cost')" :rules="getRlEntry.insp_cost_cc ? [...getRlDialogRules.required, ...getRlDialogRules.money] : [true]" label="Inspection Cost" type="number" autocomplete="off" dense />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5">
                    <v-select v-model="getRlEntry.FX_cc" :items="getCurrencyList" item-value="code" item-text="code" @input="price2Empty(getRlEntry, 'FX_rate')" label="Currency Code" dense />
                  </v-col>
                  <v-col cols="7">
                    <v-text-field v-model="getRlEntry.FX_rate" @blur="price2Dec(getRlEntry, 'FX_cc', 'FX_rate')" :rules="getRlEntry.FX_cc ? [...getRlDialogRules.required, ...getRlDialogRules.money] : [true]" label="FX Rate" type="number" autocomplete="off" dense />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="getRlEntry.other_costs_desc" :rules="[...getRlDialogRules.stringMax100]" counter="100" maxlength="100" label="Other Costs Description" autocomplete="off" dense />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5">
                    <v-select v-model="getRlEntry.other_costs_cc" :items="getCurrencyList" item-value="code" item-text="code" @input="price2Empty(getRlEntry, 'other_costs')" label="Currency Code" dense />
                  </v-col>
                  <v-col cols="7">
                    <v-text-field v-model="getRlEntry.other_costs" @blur="price2Dec(getRlEntry, 'other_costs_cc', 'other_costs')" :rules="getRlEntry.other_costs_cc ? [...getRlDialogRules.required, ...getRlDialogRules.money] : [true]" label="Other Costs" type="number" autocomplete="off" dense />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-textarea v-model="getRlEntry.notes" :rules="[...getRlDialogRules.stringMax255]" counter="255" maxlength="255" label="Notes" rows="1" auto-grow dense />
                  </v-col>
                </v-row>
              </v-form>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary darken-1" text @click.prevent="closeDialog()" :disabled="dialogLoading">Close</v-btn>
          <v-btn color="primary" @click.prevent="saveDialog()" :disabled="dialogLoading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { editDialogValidation } from '../../mixins/editDialogValidation.js'

export default {	
  mixins: [editDialogValidation],
  watch:{
    'getRlEditDialog.show'(newValue, OldValue) {
      if(newValue) {
        this.entry = this.getRlEntry         
      } else {      
        this.entry = {}
      }
    }
  },
	methods: {       
    closeDialog() {    
      this.setRlEditDialog({show: false, alert: {show: false, type: null, icon: null, message: null}})
      this.dom_haul_show = false
      this.int_ship_show = false
      this.$refs.editRlForm.$el.scrollIntoView()
    },
    async saveDialog() {
      if (this.$refs.editRlForm.validate()) {
        try {
          this.dialogLoading = true
          await axios.put('api/v1/recyclingLedgerEntries/' + this.getRlEntry.id, this.getRlEntry)
          this.dialogLoading = false
          this.setRlEditDialog({show: false, alert: {show: false, type: null, icon: null, message: null}})
          this.dom_haul_show = false
          this.int_ship_show = false
          this.$refs.editRlForm.$el.scrollIntoView()
          this.setRlEntryList() 
        } catch (error) {
          this.dialogLoading = false     
          this.setRlEditDialog({show: true, alert: {show: true, type: "error", icon: "error", message: error.response.data.message}})
          this.$refs.editRlForm.$el.scrollIntoView()
        }
      }	
    },  	
	},	
}
</script>